import React from 'react';
import { Modal, Progress } from 'antd';

export default function LoadingModal({ visible }) {
  return (
    <Modal
      width={572}
      centered
      visible={visible}
      footer={null}
      closeIcon={null}
      closable={false}
      maskClosable={false}
      wrapClassName="loading-banner-modal"
    >
      <div className="modal-wrapper">
        <div className="title">Processing...</div>
        <div className="process-bar-wrapper">
          <Progress percent={99} status="active" strokeColor="#6B92F3" />
        </div>
      </div>
    </Modal>
  );
}
